/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-08-25 10:00:55 */

const Keys = {
  select: 'select',
  ascending: 'ascending',
  descending: 'descending',
  sorting: 'sorting',
  showFurtherElements: 'showFurtherElements',
  unAvailableListItem: 'unAvailableListItem'
}; export default Keys;